import { CSSObject } from '@emotion/react';

export const wrap: CSSObject = {
  display: 'flex',
  gap: '16px',
  minWidth: '816px',
};

export const searchWrap: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minWidth: '400px',
};

export const selectedWrap: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minWidth: '400px',
};
